<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="max-content">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas borrar la referencia: "{{ `${data.reference}` }}"?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            rounded
            color="error"
            @click="closeDialog('close')">
            No
          </v-btn>
          <v-btn
            small
            rounded
            color="primary"
            @click="removeRestaurantReference">
            Si, eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isOpen: false,
      overlay: false
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data._id
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    closeDialog (typeEvent) {
      this.isOpen = false
      this.$emit(typeEvent)
    },
    async removeRestaurantReference () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/providers/${this.provider}/references/${this.data.restaurantId}/${this.data.id}`)
        this.$toasted.show(`Se eliminó exitosamente la referencia: "${this.data.reference}"`, { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-delete' })
        this.closeDialog('refresh')
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
      this.overlay = false
    }
  }
}
</script>
